// extracted by mini-css-extract-plugin
module.exports = {"GoTopButton":"GoTop_style_GoTopButton__dWCss"};